// API клиент для получения меню — через серверный прокси к RK7 SQL

export interface MenuApiResponse {
  success: boolean;
  result?: any;
  error?: string;
}

export async function getMenu(): Promise<MenuApiResponse> {
  try {
    const response = await fetch('/api/restaurant/menu');

    if (!response.ok) {
      throw new Error(`Ошибка загрузки меню: ${response.status}`);
    }

    const data = await response.json();

    if (data.success) {
      return { success: true, result: data.result };
    } else {
      return { success: false, error: data.error || 'Ошибка загрузки меню' };
    }
  } catch (error: any) {
    return { success: false, error: error.message || 'Ошибка сети' };
  }
}

// Поэтапная загрузка

export async function getMenuCategories(): Promise<{ success: boolean; categories?: any[]; error?: string }> {
  try {
    const response = await fetch('/api/restaurant/menu/categories');
    if (!response.ok) throw new Error(`Ошибка: ${response.status}`);
    const data = await response.json();
    if (data.success) {
      return { success: true, categories: data.categories };
    }
    return { success: false, error: data.error || 'Ошибка загрузки категорий' };
  } catch (error: any) {
    return { success: false, error: error.message || 'Ошибка сети' };
  }
}

export async function getMenuProducts(categoryId: string): Promise<{ success: boolean; products?: any[]; modifiersByScheme?: any; error?: string }> {
  try {
    const response = await fetch(`/api/restaurant/menu/products?category=${encodeURIComponent(categoryId)}`);
    if (!response.ok) throw new Error(`Ошибка: ${response.status}`);
    const data = await response.json();
    if (data.success) {
      return { success: true, products: data.products, modifiersByScheme: data.modifiersByScheme };
    }
    return { success: false, error: data.error || 'Ошибка загрузки продуктов' };
  } catch (error: any) {
    return { success: false, error: error.message || 'Ошибка сети' };
  }
}
